import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { OwnerType } from '../../../constants/ComponentTypes';
import { isSalesDemo } from "../../../utils/userUtils";
import moment from 'moment';
import { connect } from 'react-redux';
import { getDelayLetterOrderList } from '../../../redux/actions/LetterOrderList';
import { FLAG } from '../../../constants/Constants';

const styles = () => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
  },

  box: {
    padding: '15px 25px',
    background: '#FFFFE0',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: 5,
    boxSizing: 'border-box',
    marginBottom: 25,
    cursor: 'pointer',
  },

  detail: {
    fontSize: 14,
    marginTop: 10,
    color: '#606050',
  },

  circle: {
    width: 14,
    height: 14,
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: 5,
    verticalAlign: 'text-top',
    background: '#606050',
  },
});

class DelayLetterOrderNotification extends React.Component {
  state = {
    checkedNotifications: JSON.parse(localStorage.getItem('checked_delay_letter_order_notifications') || '[]')
  }

  componentDidMount() {
    let query = this.filterValueToQuery();
    this.props.getDelayLetterOrderNotifications({
      ...query,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ownerType && prevProps.ownerType !== this.props.ownerType) {
      let query = this.filterValueToQuery();
      this.props.getDelayLetterOrderNotifications({
        ...query,
      });
    }
  }

  filterValueToQuery = (ownerType = this.props.ownerType) => {
    let data = {};

    data["is_own"] = ownerType === OwnerType.OWN.value ? 'true' : 'false';

    return data;
  }

  handleClick = (item) => {
    // 既に同じIDのデータがローカルストレージに保存されている場合は何もしない
    if (this.state.checkedNotifications.some(notification => notification.id === item.id)) {
      return;
    }
    // 新しくチェックされた通知
    const newData = { id: item.id, created_at: item.created_at };
    const newCheckedNotifications = [...this.state.checkedNotifications, newData];
    // 通知対象は30日以内に発送予定されたデータなので30日より前のデータをローカルストレージから排除する
    const dayCountAtMonth = 30;
    const weekAgo = moment().subtract((dayCountAtMonth + 1), 'days');
    const filteredNotifications = newCheckedNotifications.filter(
      notification => moment(notification.created_at) >= weekAgo
    );
    localStorage.setItem('checked_delay_letter_order_notifications', JSON.stringify(filteredNotifications));
    this.setState({ checkedNotifications: newCheckedNotifications });

    if (item && item.order && item.order.id) {
      this.props.goTo(`/orders/${item.order.id}`);
    }
  };

  render() {
    const { classes, user, delayLetterOrderList, isLoadingDelayLetterOrderList } = this.props;
    // ロード中 or 通知がない or セールスデモユーザーの場合は表示しない
    if (isLoadingDelayLetterOrderList || !delayLetterOrderList || isSalesDemo(user)) {
      return <div></div>;
    }

    const displayNotifications = delayLetterOrderList;

    const uncheckedNotifications = displayNotifications.filter(item => !this.state.checkedNotifications.some(
      notification => notification.id === item.id)
    );

    return (
      <div className={classes.root}>
        {uncheckedNotifications.map((item, i) => (
          <div className={classes.box} key={i} onClick={() => this.handleClick(item)}>
            <Typography variant="display1" style={{ color: '#606050', fontSize: 16 }}>
              申し訳ございません。注文が混雑しておりレターの発送が遅延しております。
            </Typography>
            <div className={classes.detail}>
              <span className={classes.circle}></span>
              <span>レター注文No.{item.id}</span>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

DelayLetterOrderNotification.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  delayLetterOrderList: PropTypes.array,
  isLoadingDelayLetterOrderList: PropTypes.bool,
  getDelayLetterOrderNotifications: PropTypes.func,
  ownerType: PropTypes.string,
  goTo: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
    // [遅延レター注文通知]
    delayLetterOrderList: state.letterOrderList.delayLetterOrderList,
    isLoadingDelayLetterOrderList: state.letterOrderList.isLoadingDelayLetterOrderList,
  };
};

const mapDispatchToProps = (dispatch) => {
  // すでに閲覧済みのものはexcept_idsに入れる
  const notifications = JSON.parse(localStorage.getItem('checked_delay_letter_order_notifications')) || [];
  const ids = notifications.map(notification => notification.id);

  return {
    getDelayLetterOrderNotifications(data) {
      // 30日以内にレター注文を5件まで取得する
      const dayCountAtMonth = 30;
      dispatch(getDelayLetterOrderList(
        {
          ...data,
          'paging': 1,
          'page': 1,
          'per_page': 5,
          'order_scheduled_at_from': moment().subtract(dayCountAtMonth, 'day').format('YYYY-MM-DD'),
          'with_order': FLAG.ON,
          'except_ids': ids,
          'is_delayed': FLAG.ON,
        }
      ))
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(DelayLetterOrderNotification));



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/panels/DelayLetterOrderNotification.jsx